// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media(min-width:992px) {
    .renee-product .container{
        padding-left: 172px !important;
        padding-right: 172px !important;
        padding-bottom: 64px !important;
    }
}

@media(min-width: 768px) and (max-width: 991px) {
    .renee-product{

        padding-left: 64px;
        padding-right: 64px;
    }
}

@media(max-width: 767px) {
    .renee-product {
        background-color: white !important;
    }

    .renee-product>div>div>div {
        background-color: transparent;
        border-top: 1px solid #D9D9D9;
        margin-top: 32px;
        border-radius: 0 !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/brands/components/ReneeProductComponent.css"],"names":[],"mappings":"AAAA;IACI;QACI,8BAA8B;QAC9B,+BAA+B;QAC/B,+BAA+B;IACnC;AACJ;;AAEA;IACI;;QAEI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,kCAAkC;IACtC;;IAEA;QACI,6BAA6B;QAC7B,6BAA6B;QAC7B,gBAAgB;QAChB,2BAA2B;IAC/B;AACJ","sourcesContent":["@media(min-width:992px) {\n    .renee-product .container{\n        padding-left: 172px !important;\n        padding-right: 172px !important;\n        padding-bottom: 64px !important;\n    }\n}\n\n@media(min-width: 768px) and (max-width: 991px) {\n    .renee-product{\n\n        padding-left: 64px;\n        padding-right: 64px;\n    }\n}\n\n@media(max-width: 767px) {\n    .renee-product {\n        background-color: white !important;\n    }\n\n    .renee-product>div>div>div {\n        background-color: transparent;\n        border-top: 1px solid #D9D9D9;\n        margin-top: 32px;\n        border-radius: 0 !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
